import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from '../../components/molecules/TextField';
import css from './RequiredInput.css';

const RequiredInput = ({ value, placeholder, onChange, disabled, inputClassName, containerClass }) => (
    <div className={classNames(css.container, containerClass)}>
        <TextField
            value={value}
            onChange={onChange}
            disabled={disabled}
            inputClassName={classNames(css.cellInput, inputClassName)}
            containerClass={css.textField}
        />
        {!value && placeholder && (
            <span className={css.placeholder}>
                {placeholder} <span className={css.requiredStar}>*</span>
            </span>
        )}
    </div>
);

RequiredInput.propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    inputClassName: PropTypes.string,
    containerClass: PropTypes.string,
};

export default RequiredInput;
